import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: ${props => props.theme.typography.sizes.md};
    line-height: ${props => props.theme.typography.lineHeights.md};
    color: ${props => props.theme.colors.textPrimary};
    background-color: ${props => props.theme.colors.background};
  }

  img {
    background: none !important;
  }

  button,
  input,
  textarea,
  select {
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};
    color: ${props => props.theme.colors.textPrimary};
  }

  a {
    color: ${props => props.theme.colors.primary};
  }

  .text-justify {
    text-align: justify !important;
    text-indent: 15px !important;
  }

  textarea {
    min-height: 145px;
  }

  .form-label-invalid {
    color: ${props => props.theme.colors.danger};
    font-weight: ${props => props.theme.typography.weights.semibold};
  }

  .form-check-radio-group.is-invalid-radio-group {
    padding: ${props => props.theme.spacing.xs};
    border-radius: ${props => props.theme.radii.sm};
    background-color: ${props => props.theme.colors.rose};
    border: 1px solid ${props => props.theme.colors.danger};
  }

  .form-check-radio-group.is-invalid-radio-group .form-check-label {
    color: ${props => props.theme.colors.danger};
    font-weight: ${props => props.theme.typography.weights.semibold};
  }

  h1, h2, h3, h4, h5, h6, p, b, strong, i {
    ::selection {
      background-color: ${props => props.theme.colors.secondary};
      color: ${props => props.theme.colors.white};
    }
  }
`;
